// src/routes/Index.js
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {
  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map((route, idx) => (
        <Route key={idx} path={route.path} element={route.element} />
      ))}

      {/* Protected Routes */}
      {authProtectedRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <AuthProtected
              allowedRoles={route.allowedRoles}
              requiredPermissionsforSalon={route.requiredPermissionsforSalon}
            >
              {route.element}
            </AuthProtected>
          }
        >
          {route.children?.map((child) => (
            <Route
              key={child.path || "index"}
              index={child.index}
              path={child.path}
              element={
                <AuthProtected
                  allowedRoles={child.allowedRoles || route.allowedRoles}
                  requiredPermissions={child.requiredPermissions}
                >
                  {typeof child.component === "function"
                    ? child.component()
                    : child.component}
                </AuthProtected>
              }
            />
          ))}
        </Route>
      ))}

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export { Index as Route };
